import React, {
  //useRef,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import AuthContext from "contexts/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { useCurrentLocation, getQueryParams } from "lib/utils";
import { Trans, useTranslation } from "react-i18next";

import "material-symbols/outlined.css";
import "./style.css";

import { Header } from "components/header";
import { Footer } from "components/footer/footer";
import { Button } from "components/button";
import stores from "consts/stores.json";

//calc
import { calculateEstimate } from "lib/calculateEstimate";
import InputValidation from "components/input-validation";
//import { formatEstimationNumber } from "lib/utils";
import weightRestrictions from "consts/weight-restrictions.json";

//query params
import { LOCALE_NAME, STATE_NAME, COUNTRY_NAME } from "consts/query-params";
//assets
import LegoMan from "assets/legoman.png";
import LegoWoman from "assets/lego-woman.png";
import BgMailIn from "assets/landingMailIn.png";
import BgMailInEuro from "assets/landingMailInEuro.png";
import BgInStore from "assets/landingInStore.png";
import BgCredit from "assets/landingCredit.png";
import BgEstimate from "assets/landingEstimate.png";
// import BgEstimateEuro from "assets/landingEstimateEuro.png";
import BgBricks2 from "assets/landingBricks2.jpg";
import BgAccepted from "assets/landingAccepted.png";
import BgNotAccepted from "assets/landingNotAccepted.png";
import BgLandingHero from "assets/landingHero.png";
// import BgLandingHeroEuro from "assets/landingHeroEuro.png";
import { TradeInIcon } from "pages/svgs/tradein-logo";
import useIsMobile from "hooks/useIsMobile";
import LandingBox from "assets/landingbox.jpg";
import { PAYMENT_ARGS } from "consts/feature-config";
import useLocalizedCurrencyValue from "hooks/useLocalizedCurrencyValue";
import RewardOverviewLanding from "components/reward-overview-landing";
import useWhen from "hooks/useWhen";
// import * as Accordion from "@radix-ui/react-accordion";
// import classNames from "classnames";
import GiftCard from "assets/giftcardBig.jpg";
import ScaleIcon from "assets/icons/scale.svg";
import {
  EVENT_7,
  EVENT_18,
  EVENT_19,
  EVENT_20,
  EVENT_21,
  EVENT_22,
  trackingMap,
} from "utils/tracking";

const track = (name) => {
  const resolvedName = trackingMap[name];

  console.log(`Tracked: "${name}" as "${resolvedName}"`);

  if (window.s) {
    window.s.events = resolvedName;
    window.s.linkTrackEvents = resolvedName;
    window.s.linkTrackVars = "events";
    window.s.tl(null, "o", name);
  }
};

const Landing = () => {
  const [takeBackTypeToggle, setTakeBackTypeToggle] = useState("mail");
  const [showInStore, setShowInStore] = useState(false);
  const [weightInput, setWeightInput] = useState("");
  const [weightAlarm, setWeightAlarm] = useState(null);
  const [previousTakeBackTypeToggle, setPreviousTakeBackTypeToggle] =
    useState(`mail`);

  useEffect(() => {
    if (takeBackTypeToggle !== previousTakeBackTypeToggle) {
      setPreviousTakeBackTypeToggle(takeBackTypeToggle);
      track(takeBackTypeToggle === `store` ? EVENT_21 : EVENT_22);
    }
  }, [previousTakeBackTypeToggle, takeBackTypeToggle]);

  // translation
  const { t } = useTranslation();
  // const { i18n } = useTranslation();

  // auth
  const { user } = useContext(AuthContext);

  // Get query params
  const location = useLocation();
  const queryParams = getQueryParams(location.search);

  // Get location settings
  const { location: currentLocation } = useCurrentLocation();

  // feature flag for end of pilot revised landing page
  // const useRevisedLandingPage = useWhen(END_OF_PILOT_ARGS);

  const unit = `${t("scale.weight")}`;
  const store = currentLocation?.takebackMethod?.find((method) =>
    method.startsWith("in_store")
  )
    ? stores.find(
        (store) =>
          store.value ===
          currentLocation.takebackMethod.find((method) =>
            method.startsWith("in_store")
          )
      )
    : null;
  const storeLocation = store?.name;
  const storeAddress = store?.address;

  const quickRegHref = user
    ? `${t("urls.signup_store_checklist")}`
    : `${t("urls.signup_store_email")}`;

  const CtaButton = ({ className, additionalTracking = [] }) => {
    // If isQuickReg is true (boolean), use the store-signup/0-landing.jsx logic
    if (queryParams.isQuickReg) {
      return (
        <Button
          tracking={[EVENT_7, ...additionalTracking]}
          href={quickRegHref}
          queryParams={{
            [LOCALE_NAME]: "en-US",
            [STATE_NAME]: queryParams.state,
            [COUNTRY_NAME]: "US",
          }}
          className={className}
        >
          {t("landing.button_start_new")}
        </Button>
      );
    }
    // Default behavior
    return (
      <Button
        data-testid="default-start-trade-in"
        tracking={[EVENT_7, ...additionalTracking]}
        href={`${t("urls.trade_in_weight")}`}
        queryParams={{
          [LOCALE_NAME]: currentLocation.locale,
          [STATE_NAME]: currentLocation.state,
          [COUNTRY_NAME]: currentLocation.country,
          ...(parsedWeightInput && !weightAlarm && { w: parsedWeightInput }),
        }}
        className={className}
      >
        {t("landing.button_start_new")}
      </Button>
    );
  };

  const moveTo = (elementId, offset = 0) => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  const handleScrollTo = (e, elementId, offset) => {
    e.preventDefault();
    moveTo(elementId, offset);
  };

  const updateShowInStore = useCallback(() => {
    setShowInStore(
      currentLocation.takebackMethod.some((method) =>
        stores.some((store) => store.value === method)
      )
    );
  }, [currentLocation]);

  useEffect(() => {
    updateShowInStore();
  }, [updateShowInStore]);

  const parsedWeightInput = parseFloat(weightInput.replace(",", "."));
  const estimate = calculateEstimate(parsedWeightInput);
  // const pricePerUnit = calculateEstimate(1, currentLocation?.country);
  // const singleValue =
  //   currentLocation?.takebackDisbursement?.includes("giftcard") &&
  //   currentLocation?.takebackDisbursement?.length === 1
  //     ? estimate.gift
  //     : estimate.payment;
  // const displaySingleValue =
  //   currentLocation?.locale !== "en-US"
  //     ? singleValue.toString().replace(".", ",")
  //     : singleValue;
  const estimateGift = useLocalizedCurrencyValue(estimate.gift);
  const estimateCash = useLocalizedCurrencyValue(estimate.payment);
  // const pricePerUnitGift = useLocalizedCurrencyValue(pricePerUnit.gift);
  // const pricePerUnitCash = useLocalizedCurrencyValue(pricePerUnit.payment);

  const maxWeight =
    store && store?.return_type === "kiosk"
      ? weightRestrictions.find((weight) => weight.unit === unit).maxKiosk
      : store && store?.return_type === "drop_off"
        ? weightRestrictions.find((weight) => weight.unit === unit).maxDropOff
        : weightRestrictions.find((weight) => weight.unit === unit).maxMail;

  const handleCalcInput = (e) => {
    let inputValue = e.target.value;

    if (currentLocation?.locale !== "en-US") {
      inputValue = inputValue.replace(/[^\d,]/g, "");
      const parts = inputValue.split(",");

      if (parts[1]) {
        inputValue = `${parts[0]},${parts[1].slice(0, 1)}`;
      }

      const numericValue = parseFloat(inputValue.replace(",", "."));
      e.target.value =
        !isNaN(numericValue) && numericValue >= 0
          ? inputValue
          : inputValue === ","
            ? ","
            : "";
    } else {
      inputValue = inputValue.replace(/[^\d.]/g, "");
      const parts = inputValue.split(".");

      if (parts[1]) {
        inputValue = `${parts[0]}.${parts[1].slice(0, 1)}`;
      }

      const numericValue = parseFloat(inputValue);
      e.target.value =
        !isNaN(numericValue) && numericValue >= 0
          ? inputValue
          : inputValue === "."
            ? "."
            : "";
    }

    handleCalcInputChange(e);
  };

  const handleCalcInputChange = (event) => {
    const newValue = event.target.value;
    setWeightInput(newValue);
    setWeightAlarm(null);
    const numericValue = parseFloat(newValue.replace(",", "."));

    if (!isNaN(numericValue)) {
      if (maxWeight && numericValue > maxWeight) {
        setWeightAlarm(
          t("ui.weight_alarm_max", {
            maxWeight: maxWeight,
            unit: unit,
          })
        );
      } else {
        setWeightAlarm(null);
      }
    } else {
      setWeightAlarm(null);
    }
  };

  // const AccordionTrigger = React.forwardRef(
  //   ({ children, className, ...props }, forwardedRef) => (
  //     <Accordion.Header className="AccordionHeader text-primary text-2xl">
  //       <Accordion.Trigger
  //         className={classNames("AccordionTrigger text-left", className)}
  //         {...props}
  //         ref={forwardedRef}
  //       >
  //         <div>{children}</div>
  //         <span
  //           className="AccordionChevron material-symbols-outlined align-bottom ml-large text-secondary"
  //           aria-hidden
  //         >
  //           keyboard_arrow_down
  //         </span>
  //       </Accordion.Trigger>
  //     </Accordion.Header>
  //   )
  // );

  // const AccordionContent = React.forwardRef(
  //   ({ children, className, ...props }, forwardedRef) => (
  //     <Accordion.Content
  //       className={classNames("AccordionContent", className)}
  //       {...props}
  //       ref={forwardedRef}
  //     >
  //       <div className="AccordionContentText text-secondary mt-large mb-regular">
  //         {children}
  //       </div>
  //     </Accordion.Content>
  //   )
  // );

  const isKiosk = currentLocation?.takebackMethod
    ? stores.some(
        (store) =>
          currentLocation.takebackMethod.includes(store.value) &&
          store.return_type === "kiosk"
      )
    : false;

  //only show cash payment in appropriate environments
  const showPayment = useWhen(PAYMENT_ARGS);

  const isMobile = useIsMobile();
  const navigationLink = `${t("urls.my_trade_ins")}/${location.search}`;

  const mobileContent = (
    <>
      <Link to={navigationLink}>
        <TradeInIcon />
      </Link>
    </>
  );

  const isFullX = ["CO", "AR"].includes(queryParams.state);
  return (
    <div>
      <Header mobileChildren={mobileContent} classNames="bg-yellow border-none">
        <div className="flex gap-large">
          <CtaButton
            className="hidden lg:block"
            additionalTracking={[EVENT_18]}
          />

          {!isMobile && (
            <Button
              href={user ? `${t("urls.my_trade_ins")}` : `${t("urls.login")}`}
              variant="secondary_no_border"
              queryParams={queryParams}
            >
              {user
                ? t("landing.button_my_trade_ins")
                : t("landing.button_sign_in")}
            </Button>
          )}
        </div>
      </Header>
      <div className="bg-[#ffef87] h-[71px] mt-[-71px]"></div>
      <div
        id="hero"
        className="bg-gradient-to-b from-[#FFF087] via-[#FFE950] to-[#FFE21B] px-x-large md:px-xxxx-large relative"
      >
        <div className="bg-white/50 p-small text-center text-xs absolute bottom-0 left-0 right-0 z-20">
          <Trans
            i18nKey={"landing.pentatonic"}
            components={{
              1: (
                <Link
                  to={t("urls.terms_and_conditions")}
                  className="cursor-pointer text-blue"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </div>
        <div className="container mx-auto flex flex-col md:flex-row md:items-end gap-xx-large max-w-full md:max-w-6xl relative z-10 pb-xxx-large md:pb-0">
          <div className="mx-auto md:mx-0 mt-xx-large md:mt-[4rem] max-w-[48rem] mb-xx-large md:mb-[200px] lg:mb-xxxx-large">
            <h1 className="text-primary font-bold text-[3rem] leading-[1.2] md:text-[3.5rem] lg:text-[4rem] mb-large">
              <Trans i18nKey={"landing.hero.heading"} />
            </h1>
            <p className="text-secondary text-2xl mb-xx-large pr-0 md:pr-56 lg:pr-0 max-w-[44rem]">
              Got spare LEGO® bricks? Trade them in for a LEGO e-Gift Card with
              our limited-time LEGO Brick Take Back program.
            </p>
            <div className="flex flex-col items-stretch md:items-center md:flex-row space-y-large md:space-y-0 md:space-x-x-large max-w-screen min-w-0">
              <CtaButton className="" additionalTracking={[EVENT_19]} />
              <Button
                href="#"
                onClick={(e) => handleScrollTo(e, "howItWorks", 80)}
                variant="secondary"
                icon="arrow_downward"
                className=""
              >
                {t("landing.hero.secondary_btn")}
              </Button>
            </div>

            {/* Reward info component */}
            <div className="mt-[4rem] max-w-sm">
              <div className="flex flex-col gap-2">
                <div className="text-primary font-bold text-sm leading-5">
                  We're rewarding you for your spare LEGO bricks
                </div>
                <div
                  className="bg-white rounded-lg p-2 md:max-w-xs"
                  style={{
                    boxShadow:
                      "0px 0px 2px 1px rgba(6, 14, 35, 0.08), 0px 2px 2px -1px rgba(6, 14, 35, 0.16)",
                  }}
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={GiftCard}
                      alt="LEGO Gift Card"
                      className="w-[60px] h-[38px] object-cover rounded flex-shrink-0"
                    />
                    <div className="flex flex-col">
                      <div className="text-primary font-bold text-sm leading-5">
                        LEGO e-Gift Card
                      </div>
                      <div className="text-secondary text-xs leading-4">
                        {useLocalizedCurrencyValue(calculateEstimate(1).gift)}{" "}
                        per {t("scale.weight_label_singular").toLowerCase()} of{" "}
                        <span
                          onClick={(e) => handleScrollTo(e, "whatWeAccept", 80)}
                          className="text-blue cursor-pointer"
                        >
                          eligible bricks
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src={BgLandingHero}
          alt={t("landing.hero.image_alt")}
          className="hidden md:block md:absolute md:right-0 md:bottom-0"
        />
      </div>
      <div id="howItWorks">
        <div className="flex flex-col justify-center py-xxx-large md:py-xxxx-large px-x-large md:px-xx-large">
          <h2 className="text-primary text-[30px] md:text-[40px] leading-[39px] md:leading-[52px] font-bold text-center mb-large">
            {t("landing.how_it_works.heading")}
          </h2>
          <p className="text-secondary text-2xl text-center">
            {t("landing.how_it_works.sub_heading")}
          </p>
          <div className="mt-xx-large md:mt-xxx-large">
            {showInStore ? (
              <div className="mb-xx-large md:mb-xxxx-large">
                <h3 className="text-primary text-2xl font-bold md:text-4xl text-center">
                  Choose your trade-in method:
                </h3>
                <div className="flex flex-col md:flex-row lg:max-w-4xl mx-auto mt-regular md:mt-large bg-gray-300/25 border border-gray-300 rounded-xl p-x-small text-primary">
                  <button
                    onClick={() => setTakeBackTypeToggle("mail")}
                    className={`${
                      takeBackTypeToggle === "mail" ? "bg-blue text-white " : ""
                    }rounded-lg py-regular px-x-large text-2xl flex flex-1 items-center justify-center`}
                  >
                    <span
                      className={`material-symbols-outlined align-bottom mr-large scale-125 ${
                        takeBackTypeToggle === "mail"
                          ? "text-white"
                          : "text-[#757575]"
                      }`}
                    >
                      package_2
                    </span>
                    <span className="block truncate leading-10">
                      {t("landing.method_mail")}
                    </span>
                  </button>
                  <button
                    onClick={() => setTakeBackTypeToggle("store")}
                    className={`${
                      takeBackTypeToggle === "store"
                        ? "bg-blue text-white "
                        : ""
                    }rounded-lg py-regular px-x-large text-2xl flex flex-1 items-center justify-center`}
                  >
                    <span
                      className={`material-symbols-outlined align-bottom mr-large scale-125 ${
                        takeBackTypeToggle === "store"
                          ? "text-white"
                          : "text-[#757575]"
                      }`}
                    >
                      storefront
                    </span>
                    <span className="block truncate leading-10">
                      {t("landing.method_store", {
                        store: storeLocation,
                        asterisk: takeBackTypeToggle === "store" ? "*" : "",
                      })}
                    </span>
                  </button>
                </div>

                {takeBackTypeToggle === "store" && (
                  <div className="text-black-300 w-full text-center mt-large text-sm">
                    <span className="font-semibold ">*Address:</span>{" "}
                    {storeAddress}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            <div className="flex flex-col lg:flex-row justify-stretch mx-auto space-y-xxx-large lg:space-y-0 lg:gap-xxx-large lg:max-w-6xl">
              <div className="md:basis-1/3 flex flex-col md:flex-row-reverse lg:flex-col lg:max-w-[357px]">
                <div className="md:basis-1/2">
                  <img
                    className="w-full h-full object-cover"
                    src={BgEstimate}
                    alt=""
                  />
                </div>

                <div className="p-x-large bg-[#DF7D2F] flex flex-col md:basis-1/2 grow justify-between min-h-[350px]">
                  <div className="mb-large">
                    <div className="flex space-x-large mb-large">
                      <span className="bg-white text-center text-primary leading-[24px] font-bold text-2xl rounded-full w-6 h-6 shrink-0">
                        1
                      </span>
                      <h4 className="text-primary text-3xl font-bold">
                        {t("landing.how_it_works.step_1.heading")}
                      </h4>
                    </div>
                    <p className="text-secondary text-base">
                      {t("landing.how_it_works.step_1.body")}
                    </p>
                  </div>
                  <div className="">
                    <Button
                      href="#"
                      onClick={(e) => handleScrollTo(e, "estimate", 80)}
                      variant="secondary_no_border"
                      icon="arrow_downward"
                      className="w-fit"
                    >
                      {t("landing.how_it_works.step_1.btn")}
                    </Button>
                  </div>
                </div>
              </div>

              {takeBackTypeToggle === "mail" ? (
                <div className="md:basis-1/3 flex flex-col md:flex-row-reverse lg:flex-col lg:max-w-[357px]">
                  <div className="md:basis-1/2">
                    <img
                      src={
                        currentLocation.country === "US"
                          ? BgMailIn
                          : BgMailInEuro
                      }
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-x-large bg-[#ECB7D1] flex flex-col grow md:basis-1/2 justify-between min-h-[350px]">
                    <div className="mb-large">
                      <div className="flex space-x-large mb-large">
                        <span className="bg-white text-center text-primary leading-[24px] font-bold text-2xl rounded-full w-6 h-6 shrink-0">
                          2
                        </span>
                        <h4 className="text-primary text-3xl font-bold">
                          {t("landing.how_it_works.step_2.heading")}
                        </h4>
                      </div>
                      <p className="text-secondary text-base">
                        {t("landing.how_it_works.step_2.body")}
                      </p>
                      <p className="text-secondary text-sm">
                        <img
                          src={ScaleIcon}
                          alt="Scale icon"
                          className={`scale-[0.60] mb-[2px] inline-block`}
                        />
                        {currentLocation.state === null
                          ? "Keep each trade-in under 25.00 lbs."
                          : "Keep each trade-in under 25.00 lbs."}
                      </p>
                    </div>
                    <div>
                      <Button
                        href="#"
                        icon="arrow_downward"
                        onClick={(e) => handleScrollTo(e, "whatWeAccept", 80)}
                        variant="secondary_no_border"
                        className="w-fit"
                      >
                        {t("landing.how_it_works.step_2.btn")}
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="md:basis-1/3 flex flex-col md:flex-row-reverse lg:flex-col lg:max-w-[357px]">
                  <div className="md:basis-1/2">
                    <img
                      src={BgInStore}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-x-large bg-[#ECB7D1] flex flex-col md:basis-1/2 grow justify-between min-h-[350px]">
                    <div className="mb-large">
                      <div className="flex space-x-large mb-large">
                        <span className="bg-white text-center text-primary leading-[24px] font-bold text-2xl rounded-full w-6 h-6 shrink-0">
                          2
                        </span>
                        <h4 className="text-primary text-3xl font-bold">
                          {isKiosk
                            ? "Schedule your in-store appointment"
                            : t(
                                "landing.how_it_works.step_2_in_store.heading",
                                {
                                  store: storeLocation,
                                }
                              )}
                        </h4>
                      </div>
                      <p className="text-secondary text-base">
                        {isKiosk
                          ? "Choose the in-store option when prompted and pick your appointment date and time. Pack up your disassembled bricks and bring to the LEGO Store."
                          : "Pack up your disassembled bricks in an unsealed cardboard shipping box and drop them off at the LEGO store."}
                      </p>
                      <p className="text-secondary text-sm">
                        <img
                          src={ScaleIcon}
                          alt="Scale icon"
                          className={`scale-[0.60] mb-[2px] inline-block`}
                        />
                        Keep each trade-in under {maxWeight.toFixed(2)} lbs.
                      </p>
                    </div>
                    <div>
                      <Button
                        href="#"
                        variant="secondary_no_border"
                        onClick={(e) => handleScrollTo(e, "whatWeAccept", 80)}
                        icon="arrow_downward"
                      >
                        {t("landing.how_it_works.step_2_in_store.btn")}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              <div className="md:basis-1/3 flex flex-col md:flex-row-reverse lg:flex-col lg:max-w-[357px]">
                <div className="md:basis-1/2">
                  <img
                    src={BgCredit}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-x-large bg-[#B4CA41] flex flex-col md:basis-1/2 grow justify-between min-h-[350px]">
                  <div className="mb-large">
                    <div className="flex space-x-large mb-large">
                      <span className="bg-white text-center text-primary leading-[24px] font-bold text-2xl rounded-full w-6 h-6 shrink-0">
                        3
                      </span>
                      <h4 className="text-primary text-3xl font-bold">
                        {t("landing.how_it_works.step_3.heading")}
                      </h4>
                    </div>
                    <p className="text-secondary text-base">
                      {takeBackTypeToggle === "store"
                        ? "At the store, a Brick Specialist will weigh and verify your bricks. Then, we’ll email you a LEGO e-Gift Card!"
                        : t("landing.how_it_works.step_3.body")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-xxxx-large px-xxx-large flex flex-col justify-center items-center space-y-x-large">
            <h3 className="text-primary text-2xl font-bold md:text-4xl text-center">
              Turn your LEGO® bricks into perks
            </h3>

            <CtaButton additionalTracking={[EVENT_20]} />
          </div>
        </div>
      </div>
      <div id="whatWeAccept">
        <div className="bg-green-400 flex flex-col justify-center py-xxx-large md:py-xxxx-large px-x-large md:px-xx-large">
          <h2 className="text-primary text-[30px] md:text-[40px] leading-[39px] md:leading-[52px] font-bold text-center mb-xxx-large">
            {t("landing.what_we_accept.heading")}
          </h2>
          <div className="flex flex-col lg:flex-row justify-stretch mx-auto space-y-xxx-large lg:space-y-0 lg:gap-xxx-large lg:max-w-6xl">
            <div className="bg-white p-x-large shadow-sm flex-1">
              <div className="flex gap-large mb-large">
                <img
                  src={BgAccepted}
                  alt={t("landing.what_we_accept.accepted_icon_alt")}
                  className="w-10 h-10 shrink-0"
                />
                <h3 className="text-primary text-4xl">
                  {t("landing.what_we_accept.accepted_heading")}
                </h3>
              </div>
              <ul className="list-disc list-inside pl-regular">
                <li className="mb-large">
                  <Trans i18nKey="landing.what_we_accept.accepted_bullets.item1" />
                </li>
                <li className="mb-large">
                  {t("landing.what_we_accept.accepted_bullets.item2")}
                </li>
                <li className="mb-large">
                  {t("landing.what_we_accept.accepted_bullets.item3")}
                </li>
              </ul>
            </div>
            <div className="bg-white p-x-large shadow-sm flex-1">
              <div className="flex gap-large mb-large">
                <img
                  src={BgNotAccepted}
                  alt={t("landing.what_we_accept.not_accepted_icon_alt")}
                  className="w-10 h-10 shrink-0"
                />
                <h3 className="text-primary text-4xl">
                  {t("landing.what_we_accept.not_accepted_heading")}
                </h3>
              </div>
              <ul className="list-disc list-inside pl-regular">
                <li className="mb-large">
                  {t("landing.what_we_accept.not_accepted_bullets.item1")}
                </li>
                <li className="mb-large">
                  {t("landing.what_we_accept.not_accepted_bullets.item2")}
                </li>
                <li className="mb-large">
                  {t("landing.what_we_accept.not_accepted_bullets.item3")}
                </li>
                <li className="mb-large">
                  {t("landing.what_we_accept.not_accepted_bullets.item4")}
                </li>
                <li className="mb-large">
                  {t("landing.what_we_accept.not_accepted_bullets.item5")}
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-xxxx-large px-xxx-large flex flex-col justify-center items-center space-y-x-large">
            <h3 className="text-primary text-2xl font-bold md:text-4xl text-center">
              Looking for more info?
            </h3>
            <Link
              to={{
                pathname: t("urls.how_it_works"),
                search: `?${new URLSearchParams(queryParams).toString()}`,
              }}
              className="select-none flex items-center justify-center whitespace-nowrap rounded-full font-medium ring-offset-white transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-gray-950 dark:focus-visible:ring-gray-300 bg-blue hover:bg-blue-600 text-white disabled:bg-blue-300 disabled:opacity-100 px-[24px] py-regular leading-7"
            >
              Learn About the Process
            </Link>
          </div>
        </div>
      </div>
      <div id="reward" className="bg-blue-300/25">
        <div className="flex flex-col justify-center py-xxx-large md:py-xxxx-large px-x-large md:px-xx-large">
          {/* <h2 className="text-primary text-[30px] md:text-[40px] leading-[39px] md:leading-[52px] font-bold text-center mb-xxx-large md:mb-xxxx-large">
            {t("landing.estimate_value.heading")}
          </h2> */}
          {/* <div className="flex flex-col lg:flex-row w-full md:w-auto md:mx-auto lg:max-w-6xl">
            <div className="bg-yellow-300 rounded-xl flex relative max-w-2xl md:pr-[282px]">
              <div className="p-x-large flex flex-col gap-regular w-full">
                <h5 className="text-primary font-bold text-sm uppercase">
                  {t("landing.estimate_value.calculator.heading")}
                </h5>
                <div
                  className={`${
                    weightAlarm ? "text-black/25 " : ""
                  }text-[40px] font-semibold leading-none my-regular`}
                >
                  {!weightAlarm && parsedWeightInput > 0 ? (
                    <>
                      {showPayment
                        ? `${estimateCash} - ${estimateGift}`
                        : estimateGift}
                    </>
                  ) : (
                    <>
                      {currentLocation?.locale === "de-DE"
                        ? `0,00 ${t("currency.symbol")}`
                        : `${t("currency.symbol")}0.00`}
                    </>
                  )}
                </div>
                <div className="flex flex-col gap-y-regular">
                  <label>
                    {t("landing.estimate_value.calculator.input_label")}
                  </label>
                  <div className="flex items-center rounded-lg border border-gray-400 overflow-hidden">
                    <input
                      type="text"
                      inputMode="decimal"
                      className="flex-1 min-w-0 outline-none text-light text-primary h-12 px-3 py-2 placeholder-gray-300"
                      placeholder="0"
                      value={weightInput}
                      onChange={handleCalcInputChange}
                      onInput={handleCalcInput}
                      name="weight"
                      lang={currentLocation.locale}
                    />
                    <div className="text-secondary px-2 bg-gray-400 shrink-0 h-12 flex items-center">
                      {t("scale.weight_label")}
                    </div>
                  </div>
                  {weightAlarm && (
                    <InputValidation errorMessage={weightAlarm} />
                  )}
                  {!showPayment && (
                    <div className="flex text-sm content-center text-tertiary mt-small">
                      <span
                        className="material-symbols-outlined align-bottom mr-[6px] scale-75"
                        aria-hidden
                      >
                        info
                      </span>
                      <span>
                        {t("landing.estimate_value.calculator.input_note", {
                          unit: t("scale.weight_label_singular"),
                          value: showPayment
                            ? `${pricePerUnitCash} - ${pricePerUnitGift}`
                            : pricePerUnitGift,
                        })}
                        <button
                          onClick={(e) =>
                            handleScrollTo(e, "whatWeAccept", 100)
                          }
                          title="Navigate to What we accept"
                          className="text-blue hover:underline"
                        >
                          {t(
                            "landing.estimate_value.calculator.input_note_link"
                          )}
                          .
                        </button>
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <img
                src={LegoMan}
                alt="Smiling LEGO Minifigure"
                className="md:absolute md:right-large md:bottom-0 w-[282px] md:w-[246px] hidden sm:block"
              />
            </div>
          </div> */}
          {/* {showPayment && ( */}
          <RewardOverviewLanding handleScrollTo={handleScrollTo} />
          {/* )} */}
          {/* <div className="mt-xxx-large md:mt-xxxx-large px-xxx-large flex flex-col sm:flex-row justify-center">
            <CtaButton />
          </div> */}
        </div>
      </div>
      <div id="estimate" className="">
        <div className="flex flex-col justify-center py-xxx-large md:py-xxxx-large px-x-large md:px-xx-large">
          <h2 className="text-primary text-[30px] md:text-[40px] leading-[39px] md:leading-[52px] font-bold text-center mb-xxx-large md:mb-xxxx-large">
            {t("landing.estimate_value.heading")}
          </h2>
          <div className="flex flex-col lg:flex-row w-full md:w-auto md:mx-auto lg:max-w-6xl">
            <div className="bg-yellow-300 rounded-xl flex relative max-w-2xl md:pr-[282px]">
              <div className="p-x-large flex flex-col gap-regular w-full">
                <h5 className="text-primary font-bold text-sm uppercase">
                  {t("landing.estimate_value.calculator.heading")}
                </h5>
                <div
                  className={`${
                    weightAlarm ? "text-black/25 " : ""
                  }text-[40px] font-semibold leading-none my-regular`}
                >
                  {!weightAlarm && parsedWeightInput > 0 ? (
                    <>
                      {showPayment
                        ? `${estimateCash} - ${estimateGift}`
                        : estimateGift}
                    </>
                  ) : (
                    <>
                      {currentLocation?.locale === "de-DE"
                        ? `0,00 ${t("currency.symbol")}`
                        : `${t("currency.symbol")}0.00`}
                    </>
                  )}
                </div>
                <div className="flex flex-col gap-y-regular">
                  <label>
                    {t("landing.estimate_value.calculator.input_label")}
                  </label>
                  <div className="flex items-center rounded-lg border border-gray-400 overflow-hidden">
                    <input
                      type="text"
                      inputMode="decimal"
                      className="flex-1 min-w-0 outline-none text-light text-primary h-12 px-3 py-2 placeholder-gray-300"
                      placeholder="0.0"
                      value={weightInput}
                      onChange={handleCalcInputChange}
                      onInput={handleCalcInput}
                      name="weight"
                      lang={currentLocation.locale}
                    />
                    <div className="text-secondary px-2 bg-gray-400 shrink-0 h-12 flex items-center">
                      {t("scale.weight_label")}
                    </div>
                  </div>
                  {weightAlarm && (
                    <InputValidation errorMessage={weightAlarm} />
                  )}
                  {(() => {
                    const weightRestriction = weightRestrictions.find(
                      (w) => w.unit === unit
                    ) || { maxMail: 0, maxKiosk: 0 };
                    return (
                      <div className="flex flex-row items-center gap-2 mt-2">
                        <img
                          src={ScaleIcon}
                          alt="Scale icon"
                          className={`scale-95`}
                        />
                        <div
                          className="flex flex-col text-[10px] leading-[13px] font-normal"
                          style={{
                            fontFamily: "LEGOTypewell, sans-serif",
                            color: "#000",
                          }}
                        >
                          <span>Weight limit for each trade-in:</span>
                          <div className="flex flex-row gap-2 text-[#2c2c2c]">
                            {currentLocation.state === null ? (
                              <span className="font-bold">
                                {weightRestriction.maxMail.toFixed(2)} {unit}
                              </span>
                            ) : (
                              <>
                                <span>
                                  Mail-in:{" "}
                                  <span className="font-bold">
                                    {weightRestriction.maxMail.toFixed(2)}{" "}
                                    {unit}
                                  </span>
                                </span>
                                <span>
                                  In-Store:{" "}
                                  <span className="font-bold">
                                    {(isFullX
                                      ? weightRestriction.maxKiosk
                                      : weightRestriction.maxDropOff
                                    ).toFixed(2)}{" "}
                                    {unit}
                                  </span>
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>
              <img
                src={LegoMan}
                alt="Smiling LEGO Minifigure"
                className="md:absolute md:right-large md:bottom-0 w-[282px] md:w-[246px] hidden sm:block"
              />
            </div>
          </div>{" "}
          <div className="mt-xxx-large px-xxx-large flex flex-col justify-center items-center space-y-x-large">
            <h3 className="text-primary text-2xl font-bold md:text-4xl text-center">
              Turn your bricks into rewards
            </h3>
            <CtaButton additionalTracking={[EVENT_20]} />
          </div>
        </div>
      </div>
      <div
        id="whatHappens"
        className="flex flex-col sm:flex-row mx-auto md:h-full"
      >
        <div className="basis-1/2 md:relative">
          <img
            src={BgBricks2}
            alt="A mixture of colorful LEGO bricks"
            className="w-full object-cover h-full md:absolute md:inset-0"
          />
        </div>
        <div className="bg-green p-x-large md:p-xxx-large lg:p-xxxx-large basis-1/2 md:flex md:items-center">
          <div className="max-w-2xl">
            <h1 className="text-white text-[30px] md:text-[40px] leading-[39px] md:leading-[52px] font-bold mb-x-large">
              Why are you buying back my LEGO bricks?
            </h1>
            <p className="text-green-300 text-2xl mb-large">
              We're on a mission to keep bricks in play today, tomorrow, and for
              generations to come. This pilot will help us understand how our
              fans prefer to participate in a take-back program as we look to
              reuse or repurpose LEGO bricks. We’ll use the insights to refine
              our circular and sorting processes and learn even more about the
              best ways to keep bricks in play.
            </p>
            {/* <p className="text-green-300 text-2xl mb-xx-large">
              {t("landing.what_happens.body2")}
            </p> */}
            {/* <Button
              href={t("urls.how_it_works")}
              queryParams={queryParams}
              variant="secondary"
              className="w-fit border-none"
              icon="arrow_forward"
            >
              Learn more
            </Button> */}
          </div>
        </div>
      </div>
      <div
        id="whatNeedsToHappen"
        className="flex flex-col sm:flex-row-reverse mx-auto "
      >
        <div className="basis-1/2">
          <img
            src={LandingBox}
            alt="A mixture of colorful LEGO bricks"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="bg-[#009BD7] p-x-large md:p-xxx-large lg:p-xxxx-large basis-1/2">
          <div className="max-w-2xl">
            <h1 className="text-white text-[30px] md:text-[40px] leading-[39px] md:leading-[52px] font-bold mb-x-large">
              What happens to verify my LEGO bricks?
            </h1>
            <p className="text-green-300 text-2xl mb-large">
              When we receive your bricks, we check them to make sure they meet
              our eligibility criteria. Then it’s time for a weigh-in to
              determine your final trade-in value. After that? We’ll send your
              LEGO e-Gift Card on its way!
            </p>
          </div>
        </div>
      </div>
      <div id="faqs">
        <div className="flex flex-col justify-center pb-xxx-large md:pb-xxxx-large px-x-large md:px-xx-large items-center">
          {/* <h2 className="text-primary text-[30px] md:text-[40px] leading-[39px] md:leading-[52px] font-bold text-center mb-xxx-large">
            {t("landing.faqs.heading")}
          </h2>
          <div className="mx-auto w-full lg:max-w-6xl mb-xx-large">
            <Accordion.Root type="single" defaultValue="item-1" collapsible>
              <Accordion.Item
                className="p-large border-b border-gray-300"
                value="item-1"
              >
                <AccordionTrigger className="flex justify-between w-full">
                  Why is the LEGO Brick Take Back program not available in my
                  country?
                </AccordionTrigger>
                <AccordionContent>
                  {t("landing.faqs.questions.item1.answer")}
                </AccordionContent>
              </Accordion.Item>
              <Accordion.Item
                className="p-large border-b border-gray-300"
                value="item-2"
              >
                <AccordionTrigger className="flex justify-between w-full">
                  Do I need to clean my bricks before trading them in?
                </AccordionTrigger>
                <AccordionContent>
                  {t("landing.faqs.questions.item2.answer")}
                </AccordionContent>
              </Accordion.Item>
              <Accordion.Item
                className="p-large border-b border-gray-300"
                value="item-3"
              >
                <AccordionTrigger className="flex justify-between w-full">
                  Where can I ship my bricks from when choosing the mail-in
                  option?
                </AccordionTrigger>
                <AccordionContent>
                  {t("landing.faqs.questions.item3.answer")}
                </AccordionContent>
              </Accordion.Item>
              <Accordion.Item
                className="p-large border-b border-gray-300"
                value="item-4"
              >
                <AccordionTrigger className="flex justify-between w-full">
                  What is the maximum amount of LEGO bricks you allow per
                  trade-in?
                </AccordionTrigger>
                <AccordionContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque vitae velit ex.
                </AccordionContent>
              </Accordion.Item>
              <Accordion.Item
                className="p-large border-b border-gray-300"
                value="item-5"
              >
                <AccordionTrigger className="flex justify-between w-full">
                  What happens if the estimated weight I provide isn't correct?
                </AccordionTrigger>
                <AccordionContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque vitae velit ex.
                </AccordionContent>
              </Accordion.Item>
            </Accordion.Root>
          </div> */}
          <div className="mt-xxxx-large px-xx-large flex flex-col justify-center items-center space-y-x-large mb-xxx-large">
            <h3 className="text-primary text-2xl font-bold md:text-4xl text-center">
              Turn your bricks into rewards
            </h3>
            <CtaButton additionalTracking={[EVENT_20]} />
          </div>
          <div className="border border-gray-300 rounded-xl flex relative max-w-2xl md:pr-[282px] mt-xxx-large p-1">
            <div className="p-x-large flex flex-col gap-regular w-full space-y-small">
              <h3 className="text-primary text-2xl font-bold md:text-4xl">
                Got questions?
              </h3>
              <p className="text-primary">
                Learn how to prepare your trade-in and more details on the LEGO
                Brick Take Back program.
              </p>
              <Link
                to={{
                  pathname: t("urls.faq"),
                  search: currentLocation.state
                    ? `?state=${currentLocation.state}`
                    : `?state=null`,
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="select-none flex items-center justify-center whitespace-nowrap rounded-full font-medium ring-offset-white transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-gray-950 dark:focus-visible:ring-gray-300 bg-blue hover:bg-blue-600 text-white disabled:bg-blue-300 w-fit px-[24px] py-regular leading-7"
              >
                Visit FAQ
              </Link>
            </div>
            <img
              src={LegoWoman}
              alt="Smiling LEGO Minifigure"
              className="md:absolute md:right-large md:bottom-0 w-[282px] md:w-[246px] hidden sm:block"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Landing;
